/* eslint-disable capitalized-comments */
/* eslint-disable no-undef */
/* eslint-disable complexity */
/* eslint-disable no-unused-vars */
const handleShopifyRegister = async (event) => {
	event.preventDefault();

	const errorElement = document.querySelector('.shopify-register-error-banner.hidden');
	const errorClass = '.shopify-register-error-banner';
	if (!errorElement) {
		hiddenError(errorClass);
	}

	const firstName = document.getElementById('ShopifyRegisterForm-FirstName').value;
	const lastName = document.getElementById('ShopifyRegisterForm-LastName').value;
	const email = document.getElementById('ShopifyRegisterForm-email').value;
	const phoneNumber = document.getElementById('ShopifyRegisterForm-Phone').value;
	let errorType = 'somethingWrong';
	try {
		toggleLoadingBtn('shopify-register');
		const response = await fetch(`${PROXY}/membership/member`, {
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				uuid: sessionStorage.getItem('otp-uuid'),
				firstName,
				lastName,
				phoneNumber,
				email,
			}),
		});

		const jsonShopifyUrl = await response.json();

		if (!response.ok || !jsonShopifyUrl.success || !jsonShopifyUrl.redirectUrl) {
			errorType = jsonShopifyUrl.message ?? 'somethingWrong';
			console.log('er type', errorType)
			throw new Error(errorType);
		}
		
		window.location.replace(jsonShopifyUrl.redirectUrl);
	} catch (error) {
		console.log('er type 2', errorType)

		showError(errorClass, errorType);
	} finally {
		toggleLoadingBtn('shopify-register');
	}
};
